import React from 'react';
const stats = [{
  value: '6',
  label: 'Complete Volumes'
}, {
  value: '40+',
  label: 'Ready-to-Teach Sequences'
}, {
  value: '360+',
  label: 'Pages of Content'
}, {
  value: '5',
  label: 'Free Bonuses Included'
}];
export function StatsBar() {
  return <section aria-label="Key numbers" className="w-full bg-teal px-5 py-10 sm:py-12" data-id="element-170" data-mp="1odhvgwzv7kyn">
      <dl className="mx-auto grid max-w-5xl grid-cols-2 gap-8 text-center lg:grid-cols-4" data-id="element-171" data-mp="1jc2f3i8mu2ml">
        {stats.map(stat => <div key={stat.label} data-id="element-172" data-mp="19misc1hstomg">
            <dt className="sr-only" data-id="element-173" data-mp="19m8yu3xjozc0">{stat.label}</dt>
            <dd data-id="element-174" data-mp="19ko68jusjqgs">
              <span className="block text-3xl font-extrabold text-cream sm:text-4xl" data-id="element-175" data-mp="15kntd3ncbnbu">
                {stat.value}
              </span>
              <span className="mt-2 block text-xs font-medium uppercase tracking-[0.14em] text-sage-tint/80 sm:text-sm sm:tracking-[0.1em]" data-id="element-176" data-mp="10mvprcdc2crt">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}